import * as React from 'react';
import { compose, pure } from 'recompose';
import { WrappedFieldMetaProps } from 'redux-form';

import { FormControl, InputLabel, Omit, Theme } from '@material-ui/core';
import MuiSelect, { SelectProps as SelectMUIProps } from '@material-ui/core/Select';
import { createStyles, withStyles, WithStyles } from '@material-ui/styles';

export interface SelectPublicProps extends SelectMUIProps {
  name: string;
  classes?: Partial<WithStyles<typeof styles>['classes']>;
  label: string;
  input: any;
  meta: WrappedFieldMetaProps;
}

interface SelectPrivateProps extends Omit<SelectPublicProps, 'classes'>, WithStyles<typeof styles, true> {}

const styles = (theme: Theme) => {
  // console.log('-****- theme', theme);

  return createStyles({
    root: {
      width: '100%',
    },
    inputRoot: {
      color: 'currentColor',
    },
    icon: {
      color: 'currentColor',
      opacity: 0.54,
    },
    select: {
      paddingTop: 7,
      paddingBottom: 2,
    },
  });
};

const Select: React.FC<SelectPrivateProps> = (props) => {
  const {
    input,
    classes,
    className,
    label,
    required,
    meta: { touched, error } = { touched: false, error: false },
    children,
    ...others
  } = props;

  const { inputRoot, ...overrides } = classes;

  const labelBox = label && <InputLabel shrink>{label}</InputLabel>;

  return (
    <FormControl required={required} error={touched && Boolean(error)} fullWidth className={className}>
      {labelBox}
      <MuiSelect {...input} fullWidth classes={overrides} className={inputRoot} {...others}>
        {children}
      </MuiSelect>
      {/*{renderFromHelper({ touched, error })}*/}
    </FormControl>
  );
};

const ComposedSelect = compose<SelectPrivateProps, SelectPublicProps>(
  withStyles(styles, { withTheme: true }),
  pure,
)(Select);

ComposedSelect.displayName = 'Select';

export default ComposedSelect;
